import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Typography as Text } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-1)',
    minWidth: 0,
    flex: 1,
  },
});

type TextProps = ComponentPropsWithoutRef<typeof Text>;

interface ListItemTextWithPrimarySecondaryProps {
  primary?: ReactNode;
  secondary?: ReactNode;
  children?: never;
  className?: string;
  disableText?: boolean;
}

interface ListItemTextWithChildrenProps extends Omit<TextProps, 'children'> {
  primary?: never;
  secondary?: never;
  children: ReactNode;
}

export type ListItemTextProps =
  | ListItemTextWithPrimarySecondaryProps
  | ListItemTextWithChildrenProps;

export const ListItemText = (props: ListItemTextProps) => {
  const classes = useStyles();

  if ('children' in props && props.children !== undefined) {
    const { children, variant = 'body1', ...textProps } = props;
    return (
      <Text component="div" variant={variant} {...textProps}>
        {children}
      </Text>
    );
  }

  const { primary, secondary, className, disableText } =
    props as ListItemTextWithPrimarySecondaryProps;

  if (disableText) {
    return (
      <div className={classNames(classes.root, className)}>
        {primary}
        {secondary}
      </div>
    );
  }

  return (
    <div className={classNames(classes.root, className)}>
      {primary && (
        <Text
          variant="body1"
          component="div"
          noWrap
          style={{
            fontWeight: 'bold',
          }}
        >
          {primary}
        </Text>
      )}
      {secondary && (
        <Text variant="caption" component="div" color="textSecondary" noWrap>
          {secondary}
        </Text>
      )}
    </div>
  );
};

ListItemText.displayName = 'ListItem.Text';
